import { Img, Hr } from "@react-email/components";

function ItemRow({ img, name, quantity, price }) {
	return (
		<tr>
			<td style={{ width: "30%" }}>
				<Img src={img} width={100} alt="Selected product preview" />
			</td>
			<td style={{ width: "40%", textAlign: quantity ? "left" : "center" }}>
				{name}
			</td>
			{quantity ? <td style={{ width: "15%" }}>x{quantity || 1}</td> : null}
			<td style={{ width: quantity ? "15%" : "30%" }}>
				{price ? `$${(price * quantity).toFixed(2)}` : "FREE"}
			</td>
		</tr>
	);
}

function PriceSection({
	totalMsrp,
	totalDiscount,
	promoCode,
	subTotal,
	shipping,
	withPromoPrice,
	tax,
	total,
}) {
	return (
		<>
			<tr>
				<td colSpan={100}>
					<Hr />
				</td>
			</tr>
			<tr style={{ textAlign: "right" }}>
				<td colSpan={2}>Total MSRP:</td>
				<td colSpan={2}>${totalMsrp?.toFixed(2)}</td>
			</tr>

			<tr style={{ textAlign: "right", color: "red" }}>
				<td colSpan={2}>Discount:</td>
				<td colSpan={2}>-${totalDiscount?.toFixed(2) || "0.00"}</td>
			</tr>

			{/* Put Promo Code Discount Here */}
			{promoCode ? (
				<>
					<tr style={{ textAlign: "right", color: "red" }}>
						<td colSpan={2}>Promo Code:</td>
						<td colSpan={2}>{promoCode}</td>
					</tr>
					<tr style={{ textAlign: "right", color: "red" }}>
						<td colSpan={2}>Promo Code Discount:</td>
						<td colSpan={2}>-${withPromoPrice?.toFixed(2) || "0.00"}</td>
					</tr>
				</>
			) : null}

			{/* Total Before Shipping and Tax  */}
			<tr style={{ textAlign: "right", color: "red" }}>
				<td colSpan={2}>Sub Total:</td>
				<td colSpan={2}>${subTotal.toFixed(2)}</td>
			</tr>

			<tr style={{ textAlign: "right" }}>
				<td colSpan={2}>Shipping:</td>
				<td colSpan={2}>${shipping.toFixed(2)}</td>
			</tr>

			<tr style={{ textAlign: "right" }}>
				<td colSpan={2}>Sales Tax:</td>
				<td colSpan={2}>${tax.toFixed(2)}</td>
			</tr>

			{/* <tr style={{ textAlign: 'right' }}>
        <td colSpan={2}>Total:</td>
        <td colSpan={2}>
          ${(parseFloat(subtotal) + parseFloat(discount))?.toFixed(2) || '0.00'}
        </td>
      </tr> */}
			<tr>
				<td colSpan={100}>
					<Hr />
				</td>
			</tr>
			<tr style={{ textAlign: "right" }}>
				<td colSpan={2}>Total:</td>
				<td colSpan={2}>${total?.toFixed(2) || "0.00"}</td>
			</tr>
		</>
	);
}

export default function OrderSection({
	orderDate,
	orderNumber,
	productList,
	prices,
	address,
	name,
	shippingType,
	phoneNumber,
}) {
	return (
		<>
			<h2>
				Order Number: #<u>{orderNumber}</u>
			</h2>
			<h3>
				Shipping Type: <u>{shippingType}</u>{" "}
				{shippingType === "Express" ? "(+$10)" : "(FREE)"}
			</h3>
			<h4>
				Order Date: <u>{orderDate.toLocaleString("en-US")}</u>
			</h4>
			<div style={{ textAlign: "left" }}>ITEMS ORDERED</div>
			<hr />
			<table style={{ width: "100%" }}>
				<thead>
					<tr style={{ fontWeight: "bolder" }}>
						<td style={{ width: "30%", textAlign: "left" }}>Product Preview</td>
						<td style={{ width: "40%" }}>Name</td>
						{productList[0].quantity ? (
							<td style={{ width: "15%" }}>Quantity</td>
						) : null}
						<td style={{ width: productList[0].quantity ? "15%" : "30%" }}>
							Price
						</td>
					</tr>
				</thead>
				<tbody>
					{productList?.map((product) => (
						<ItemRow {...product} />
					))}
					{prices ? <PriceSection {...prices} /> : null}
					<tr>
						<td colSpan={100}>
							<Hr />
						</td>
					</tr>

					<tr>
						<td
							colSpan={100}
							style={{ textAlign: "left", fontWeight: "bolder" }}
						>
							Name: {name}
						</td>
					</tr>
					<tr>
						<td colSpan={100}></td>
					</tr>

					<tr>
						<td
							colSpan={100}
							style={{ textAlign: "left", fontWeight: "bolder" }}
						>
							Phone Number: {phoneNumber}
						</td>
					</tr>
					<tr>
						<td colSpan={100}></td>
					</tr>

					<tr>
						<td
							colSpan={100}
							style={{ textAlign: "left", fontWeight: "bolder" }}
						>
							Shipping Address: {address}
						</td>
					</tr>
					<tr>
						<td colSpan={100} style={{ textAlign: "left" }}>
							{/* {address} */}
						</td>
					</tr>
				</tbody>
			</table>
			<hr />
		</>
	);
}
